import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class ConsultaCea {
  constructor (args = {}) {
    Object.keys(args)
      .forEach(c => { this[c] = args[c] })
  }

  static getById (numero) {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_carga_entrante_automotor?r=` +
      `{"clave":{"carta_de_porte_automotor": "${numero}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static consultaCamionesCalados (fechaD, fechaH, agrupado) {
    const axios = getAxiosInstance()
    const orden = (agrupado) ? '"orden": ["vendedor","d:fecha_de_calado"]' : '"orden": ["d:fecha_de_calado"]'
    const filtro = `{"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}, ${orden}}`
    const promise = axios.get(`/consulta_camiones_calados?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
      .catch(lrsAdapter)
  };

  static consultaCamionesCaladosTodos (fechaD, fechaH, agrupado) {
    const axios = getAxiosInstance()
    const orden = (agrupado) ? '"orden": ["vendedor","d:fecha_de_calado"]' : '"orden": ["d:fecha_de_calado"]'
    const filtro = `{"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}, ${orden}}`
    const promise = axios.get(`/consulta_camiones_calados_todos?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
      .catch(lrsAdapter)
  };

  static consultaCamionesDescargados (fechaD, fechaH, agrupado = false) {
    const axios = getAxiosInstance()
    const orden = (agrupado) ? '"orden": ["vendedor","d:fecha_de_destare"]' : '"orden": ["d:fecha_de_destare"]'
    const promise = axios.get(`/consulta_cea_con_peso_neto_entre_fechas?r={"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}, ${orden}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
      .catch(lrsAdapter)
  }

  static consultaCamionesDescargadosSinEntregador (fechaD, fechaH, agrupado) {
    const axios = getAxiosInstance()
    const orden = (agrupado) ? '"orden": ["vendedor","d:fecha_de_destare"]' : '"orden": ["d:fecha_de_destare"]'
    const promise = axios.get(`/consulta_cea_con_peso_neto_entre_fechas_sin_entregador?r={"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}, ${orden}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
      .catch(lrsAdapter)
  }

  static getFotoCea (numero) {
    const axios = getAxiosInstance()
    const orden = '"orden": ["d:fecha_de_ingreso"]'
    const promise = axios.get(`foto_cpa_ingreso_calado?r=` +
     `{"clave":{"nro_ctge": "${numero}"}, ${orden}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((data) => { return data.data[0] })
      .catch(lrsAdapter)
  }

  static deleteFotoCea (fechaPreingreso) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`foto_cpa_ingreso_calado?r=` +
    `{"clave": {"fecha_de_ingreso": "${fechaPreingreso}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data })
  }
}

export default ConsultaCea
